/* Accessibility fixes (added Oct 15, 2026).
   1. Content hidden from screen readers (aria-hidden="true"), such as off-screen
      carousel slides, must not be reachable with the Tab key either.
   2. Image zoom buttons get a name.
   3. Empty headings stop being announced as headings. */
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var MARK = 'data-a11y-tabindex';

  function syncHidden(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';
    var items = el.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < items.length; i++) {
      var f = items[i];
      if (hidden) {
        if (!f.hasAttribute(MARK)) {
          var orig = f.getAttribute('tabindex');
          f.setAttribute(MARK, orig === null ? '' : orig);
        }
        f.setAttribute('tabindex', '-1');
      } else if (f.hasAttribute(MARK)) {
        var o = f.getAttribute(MARK);
        if (o === '') { f.removeAttribute('tabindex'); } else { f.setAttribute('tabindex', o); }
        f.removeAttribute(MARK);
      }
    }
  }

  function visibleText(el) {
    var copy = el.cloneNode(true);
    var junk = copy.querySelectorAll('style, script, svg');
    for (var j = 0; j < junk.length; j++) { junk[j].remove(); }
    return copy.textContent.trim();
  }

  function fixAll() {
    var hiddenEls = document.querySelectorAll('[aria-hidden="true"], [' + MARK + ']');
    for (var i = 0; i < hiddenEls.length; i++) {
      var el = hiddenEls[i].hasAttribute(MARK) ? hiddenEls[i].closest('[aria-hidden]') : hiddenEls[i];
      if (el) { syncHidden(el); }
    }
    var zooms = document.querySelectorAll('button.zoom_btn:not([aria-label])');
    for (var z = 0; z < zooms.length; z++) { zooms[z].setAttribute('aria-label', 'Zoom image'); }
    var heads = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
    for (var h = 0; h < heads.length; h++) {
      if (!visibleText(heads[h]) && !heads[h].querySelector('img[alt]:not([alt=""])')) {
        heads[h].setAttribute('role', 'presentation');
      }
    }
  }

  var queued = false;
  function queue() {
    if (queued) { return; }
    queued = true;
    requestAnimationFrame(function () { queued = false; fixAll(); });
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes') { syncHidden(m.target); } else { queue(); return; }
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  } else {
    fixAll();
  }
  window.addEventListener('load', fixAll);
})();
